/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Footer Link Component
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.1.1
 */

import React, { useCallback } from 'react';

import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Dispatch } from 'redux';

import GTMOperations from '../../../modules/analytics/GoogleTagManager/GTMOperations';
import { logBusinessEvent } from '../../../modules/logging/loggingActions';
import { ILogBusinessEventPayload } from '../../../modules/logging/loggingTypes';
import { FooterLinkStyled } from './styled/FooterStyled';

export interface IFooterLinkProps {
    dataAttr: string;
    isExternalUrl?: boolean;
    label: string;
    logBusinessEvent: (payload: ILogBusinessEventPayload) => void;
    logBusinessEventPayload?: ILogBusinessEventPayload;
    to: string;
}

export const FooterLink = (props: IFooterLinkProps & IMapDispatchToProps) => {
    const {
        dataAttr,
        isExternalUrl,
        label,
        logBusinessEvent,
        logBusinessEventPayload,
        to,
    } = props;

    const onClick = useCallback(() => {
        if (logBusinessEventPayload) {
            logBusinessEvent(logBusinessEventPayload);
        }
        GTMOperations.navigation.tabFooterClickOperation(label, 'Footer');
    }, [label, logBusinessEvent, logBusinessEventPayload]);

    const onMouseDownHandler = useCallback((event: React.MouseEvent) => {
        if (event.button === 1) {
            event.preventDefault();
            onClick();
        }
    }, [onClick]);

    return <FooterLinkStyled className="footer__link" onClick={onClick} onMouseDown={onMouseDownHandler}>
        {
            isExternalUrl
                ? <a data-footer-link={dataAttr} href={to}>{label}</a>
                : <NavLink data-footer-link={dataAttr} to={to}>
                    {label}
                </NavLink>
        }

    </FooterLinkStyled>;
};

interface IMapDispatchToProps {
    logBusinessEvent: (payload: ILogBusinessEventPayload) => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): IMapDispatchToProps => ({
    logBusinessEvent: (payload) => dispatch(logBusinessEvent(payload)),
});

export default connect(null, mapDispatchToProps)(FooterLink);
